// document.addEventListener("DOMContentLoaded", () => {
//     const fields = {
//     f_name: '.f__name',
//     l_name: '.l__name',
//     phone: '.input_phone',
//     email: '.input_email',
//     // company: '.input_company',
//     // city: '.input_city',
//     // model: '.input_model',
//     // vehicle_vn: '.input_vehicle_vn',
//     consent: '.input_consent',
//     enquiryRelatedTo: '.input_enquiry',
//     message: '.input_msg'
//   };
  
//   // const f_name = document.querySelector('.f__name');
//   // const l_name = document.querySelector('.l__name');
//   // const phone = document.querySelector('.input_phone');
//   // const email = document.querySelector('.input_email');
//   // const company = document.querySelector('.input_company');
//   // const city = document.querySelector('.input_city');
//   // const model = document.querySelector('.input_model');
//   // const vehicleVN = document.querySelector('.input_vehicle_vn');
//   // const part = document.querySelector('.input_part');
//   // const enquiryDropdown = document.querySelector('.input_enquiry'); 
//   // const message = document.querySelector('.input_msg'); 
//   // const enquiryRelatedTo = document.querySelector('input[name="enquiry_related_to"]:checked')?.value || null;
//   // const product__id = document.querySelector('#product__id');
//   // const product__url = document.querySelector('#product__url');
//   // const product__title = document.querySelector('#product__title');
//   // const product__sku = document.querySelector('#product__sku');
//   // const product__image = document.querySelector('#product__image');
//   // const product__selected__variant = document.querySelector('#product__selected__variant');
//   // const productQTY = document.querySelector('#productQTY');
//   // const urlHiddenInput = document.querySelector('#urlHiddenInput');

//   const validationRules = {
//     f_name: { selector: '.f__name', error: '.f_name_error', message: 'This field is required.' },    
//     email: { selector: '.input_email', error: '.email_error', pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'This field is required.' },
//     phone: { selector: '.input_phone', error: '.phone_error', pattern: /^\+27\s\d{2}\s\d{3}\s\d{4}$, message: 'This field is required.' },
//     consent: { selector: '.input_consent', error: '.consent_error', message: 'This field is required.' },
//     // company: { selector: '.input_company', error: '.company_error', message: 'Please enter company name' },
//     // city: { selector: '.input_city', error: '.city_error', message: 'Please enter city name' },    
//     // model: { selector: '.input_model', error: '.model_error', message: 'Please select an option' },
//     // vehicle_vn: { selector: '.input_vehicle_vn', error: '.vehicle_vn_error', message: 'Please select an option' },
//     // part: { selector: '.input_part', error: '.part_no_error', message: 'Please select an option' },
//     enquiryRelatedTo: { selector: '.input_enquiry', error: '.enquiry_error', message: 'This field is required.' }
//   };
  
//   const formSubmitSelector = document.querySelectorAll('.EnquiryForm');
//     formSubmitSelector.forEach(form => {
//       form.addEventListener("submit", (e) => {
//         e.preventDefault();       
//         // formSubmitFunction();
//         if (!grecaptcha.getResponse()) {         
//           alert('Please verify that you are not a robot.');
//           return;
//         }
//         if (validateForm()) {
//           runApi(form);
//         }
//       });
//     });
//   // function formSubmitFunction() {
//   //   validateForm(); 
//   // }
//    function validateForm() {
//       let isValid = true;  
//        Object.values(validationRules).forEach(rule => {
//           if (!validateField(rule.selector, rule.error, rule.pattern, rule.message)) {
//             isValid = false;
//           }
//         });
//         return isValid;
//       // Validate each field and set isValid to false if any validation fails
//       // if (!validateField(".f__name", ".f_name_error", null, "Please enter first name")) isValid = false;
//       // if (!validateField(".l__name", ".l_name_error", null, "Please enter last name")) isValid = false;
//       // if (!validateField(".input_email", ".email_error", /^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter your email")) isValid = false;
//       // if (!validateField(".input_phone", ".phone_error", /^\d{10}$/, "Please enter your mobile number")) isValid = false;
//       // if (!validateField(".input_company", ".company_error", null, "Please enter company name")) isValid = false;
//       // if (!validateField(".input_city", ".city_error", null, "Please enter city name")) isValid = false;
//       // if (!validateField(".input_enquiry", ".enquiry_error", null, "Please select an option")) isValid = false;
//       // if (!validateField(".input_model", ".model_error", null, "Please select an option")) isValid = false;
//       // if (!validateField(".input_vehicle_vn", ".vehicle_vn_error", null, "Please select an option")) isValid = false;
//       // if (!validateField(".input_part", ".part_no_error", null, "Please select an option")) isValid = false;      
  
//      // if (isValid) {       
//      //    runApi();
//      //  }
//     }
  
//     function validateField(inputSelector, errorSelector, pattern = null, errorMessage = "This field is required.") {
//       const input = document.querySelector(inputSelector);
//       const errorDiv = document.querySelector(errorSelector);      
     
//       const value = input?.value.trim();
//       if (!value) {
//         errorDiv.textContent = errorMessage;
//         return false;
//       } else if (pattern && !pattern.test(value)) {
//         errorDiv.textContent = `Invalid ${inputSelector.slice(7).replace('_', ' ')}.`;
//         return false;
//       }    
//       errorDiv.textContent = "";  
//       return true;
//     }
  
//   async function runApi(form) {
//     const button = document.getElementById("sendToEnquire");    
//     button.disabled = true;
//     const formdata = new FormData();
//     for (let key in fields) {
//       const selector = fields[key];
//       const input = document.querySelector(selector);
//       if (input) {
//         formdata.append(key, input.value);
//       }
//     }
      
//       // Append form data dynamically (using actual form field values)
//       // formdata.append("f_name", f_name.value);
//       // formdata.append("l_name", f_name.value);
//       // formdata.append("phone", phone.value);
//       // formdata.append("email", email.value);
//       // formdata.append("company", company.value);      
//       // formdata.append("city", city.value);
//       // formdata.append("model", model.value);
//       // formdata.append("vehicle_vn", vehicleVN.value);
//       // formdata.append("part", part.value);
//       // formdata.append("enquiryRelatedTo", enquiryDropdown.value);
//       // formdata.append("message", message.value);
    
//       // formdata.append("productID", product__id.value);
//       // formdata.append("productTitle", product__title.value);
//       // formdata.append("productSKU", product__sku.value);
//       // formdata.append("productImage", product__image.value);
//       // formdata.append("selectedVariant", product__selected__variant.value);
//       // formdata.append("productQTY", productQTY.value);
//       // formdata.append("web_url", urlHiddenInput.value);

//       // Prepare headers (if necessary)
//       // let headersList = {
//       //   "Content-Type": "multipart/form-data", // Ensure the content type is set for file uploads
//       //   // Add any other headers you may need
//       // };

//       // Create the API request options
//       // let reqOptions = {
//       //   url: "",
//       //   method: "POST",
//       //   headers: headersList,
//       //   data: formdata,
//       // };

//       try {
//        let response = await axios.post('https://tataintl.binaryic.in/create_enquiry', formdata);
//       //  console.log("Response data:", response.data);
//         const myResponse = response.data.success ;
//           if(myResponse === true){
//           // const fromSelector = document.querySelector('#EnquiryForm');
//           const messageSelector = document.querySelector('#successMessage');
//           form.reset();
//           form.style.display = 'none';
//           messageSelector.style.display = 'block';                   
//           button.disabled = false;     
//         }        
//       } catch (error) {
//           console.error("Error in API request:", error);
//           button.disabled = false;        
//         } finally {
//           button.disabled = false;
//         }
//       }

//       // document.querySelector(".input_name").addEventListener("blur", function() {
//       //   validateField(".input_name", ".name_error", null, "Please enter your name");
//       // });
//       // document.querySelector(".input_email").addEventListener("blur", function() {
//       //   validateField(".input_email", ".email_error", /^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter your email");
//       // });
//       // document.querySelector(".input_phone").addEventListener("blur", function() {
//       //   validateField(".input_phone", ".phone_error", /^\d{10}$/, "Please enter your mobile number");
//       // });     
//     Object.values(validationRules).forEach(rule => {
//       const input = document.querySelector(rule.selector);
//       if (input) {
//         input.addEventListener('blur', () => {
//           validateField(rule.selector, rule.error, rule.pattern, rule.message);
//         });
//       }
//     });
//     const phoneInput = document.querySelector(fields.phone);
//     if (phoneInput) {
//       const formatPhone = (e) => {
//         let input = e.target.value.replace(/\D/g, '').substring(0, 10); // Remove non-digits, limit to 10
//         const areaCode = input.substring(0, 3);
//         const middle = input.substring(3, 6);
//         const last = input.substring(6, 10);
  
//         if (input.length > 6) {
//           e.target.value = `(${areaCode}) ${middle}-${last}`;
//         } else if (input.length > 3) {
//           e.target.value = `(${areaCode}) ${middle}`;
//         } else if (input.length > 0) {
//           e.target.value = `(${areaCode}`;
//         }
//       };
//       const events = ["input", "keydown", "keyup", "change", "paste", "unmask"];
//       events.forEach(evt => phoneInput.addEventListener(evt, formatPhone));
//     }
//         phoneInput.addEventListener("keydown", function (e) {
//         // Allow: backspace, delete, tab, escape, enter, arrows
//         if (
//           [46, 8, 9, 27, 13, 110, 190].includes(e.keyCode) ||
//           // Allow: Ctrl/cmd+A
//           (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
//           // Allow: Ctrl/cmd+C
//           (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
//           // Allow: Ctrl/cmd+V
//           (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
//           // Allow: home, end, left, right
//           (e.keyCode >= 35 && e.keyCode <= 39)
//         ) {
//           return; // allow those keys
//         }
      
//         // Block non-numeric keys
//         if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
//           e.preventDefault();
//         }
//       });
// });




document.addEventListener("DOMContentLoaded", () => {
  const fields = {
    firstname: '.f__name',
    lastname: '.l__name',
    mobile: '.input_phone',
    email: '.input_email',
    consent: '.input_consent',
    brand: '.input_enquiry',
    message: '.input_msg',
    chasis_no: '.input_chasis',
    v_model: '.input_model',
    part_description: '.input_description'
  };

  const validationRules = {
    firstname: { selector: '.f__name', error: '.f_name_error', message: 'This field is required.' },
    lastname: { selector: '.l__name', error: '.l_name_error', message: 'This field is required.' },
    email: {
      selector: '.input_email',
      error: '.email_error',
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Invalid email format.'
    },
    mobile: {
      selector: '.input_phone',
      error: '.phone_error',
      pattern: /^\d{3}\d{3}\d{3}$/,
      message: 'Phone number must be in +27 123456789 format.'
    },
    consent: { selector: '.input_consent', error: '.consent_error', message: 'Consent is required.' },
    brand: { selector: '.input_enquiry', error: '.enquiry_error', message: 'This field is required.' }
  };

  document.querySelectorAll('.EnquiryForm').forEach(form => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (validateForm()) {
        await runApi(form);
      }
    });
  });

  function validateForm() {
    let isValid = true;
    Object.values(validationRules).forEach(rule => {
      if (!validateField(rule.selector, rule.error, rule.pattern, rule.message)) {
        isValid = false;
      }
    });
    return isValid;
  }

  function validateField(inputSelector, errorSelector, pattern = null, errorMessage = "This field is required.") {
    const input = document.querySelector(inputSelector);
    const errorDiv = document.querySelector(errorSelector);
    const value = input?.value.trim();

    if (!value) {
      errorDiv.textContent = errorMessage;
      return false;
    } else if (pattern && !pattern.test(value)) {
      errorDiv.textContent = `Invalid format.`;
      return false;
    }

    errorDiv.textContent = "";
    return true;
  }

  async function runApi(form) {
    const button = document.getElementById("sendToEnquire");
    const btnText = button.querySelector('.btn-text');
    const btnLoader = button.querySelector('.btn-loader');
    button.disabled = true;
    btnText.style.display = 'none';
    btnLoader.style.display = 'inline-block';
    const formdata = new FormData();
    for (let key in fields) {
      const input = document.querySelector(fields[key]);
      if (input) {
        if (key === 'mobile') {
          formdata.append(key, `+27 ${input.value}`);
        } else {
          formdata.append(key, input.value);
        }
      }
    }

    try {
      const response = await axios.post(
        'https://tataintl.binaryic.in/create_enquiry',
        formdata,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bin@ry-dEv'  // replace if the API expects a different header
          }
        }
      );

      if (response.data.status === true && response.data.code === 200) {
       for (let key in fields) {
        const input = document.querySelector(fields[key]);
        if (!input) continue;
      
        const tag = input.tagName.toLowerCase();
        const type = input.type;
      
        if (tag === 'input' || tag === 'textarea') {
          if (type === 'checkbox' || type === 'radio') {
            input.checked = false;
          } else {
            input.value = '';
          }
        } else if (tag === 'select') {
          input.selectedIndex = 0;
        }
      }

        const messageSelector = document.querySelector('#successMessage');
        if (messageSelector) {
          messageSelector.style.display = 'block';
          setTimeout(() => {
    messageSelector.style.display = 'none';
  }, 3000); // 3000 milliseconds = 3 seconds
        }
      }
    } catch (error) {
      console.error("API request failed:", error);
    } finally {
      button.disabled = false;
      btnText.style.display = 'inline-block';
    btnLoader.style.display = 'none';
    }
  }

  Object.values(validationRules).forEach(rule => {
    const input = document.querySelector(rule.selector);
    if (input) {
      input.addEventListener('blur', () => {
        validateField(rule.selector, rule.error, rule.pattern, rule.message);
      });
    }
  });

  const phoneInput = document.querySelector(fields.mobile);
  if (phoneInput) {
    const formatPhone = (e) => {
      let input = e.target.value.replace(/\D/g, '').substring(0, 10);
      const area = input.substring(0, 3);
      const middle = input.substring(3, 6);
      const last = input.substring(6, 9);

      if (input.length > 6) {
        e.target.value = `${area}${middle}${last}`;
      } else if (input.length > 3) {
        e.target.value = `${area}${middle}`;
      } else if (input.length > 0) {
        e.target.value = `${area}`;
      }
    };

    ["input", "keydown", "keyup", "change", "paste"].forEach(evt => {
      phoneInput.addEventListener(evt, formatPhone);
    });

    phoneInput.addEventListener("keydown", function (e) {
      const allowedKeys = [46, 8, 9, 27, 13, 37, 38, 39, 40];
      const ctrlCommands = [65, 67, 86];

      if (
        allowedKeys.includes(e.keyCode) ||
        (ctrlCommands.includes(e.keyCode) && (e.ctrlKey || e.metaKey))
      ) {
        return;
      }

      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  }
});



